/**
 * url格式化
 */
export function formatURL (url, baseUrl = "http://www.gdzjhg.com") {
  let resUrl = url
  if (
    url.substr(0, 7).toLowerCase() == "http://" ||
    url.substr(0, 8).toLowerCase() == "https://"
  ) {
    resUrl = url
  } else {
    resUrl = baseUrl + url
  }

  return resUrl
}
